import React, { useEffect, useRef, useState } from 'react';
import { getAdminActions } from '../../../config/actions';
import Top from '../Top';
import QuickActionsSidebar from '../DistributorDashboard/QuickActionsSidebar';
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from 'react-router-dom';
import "./TutorialRecordings.css";




const useStyles = makeStyles(() => ({
    customTooltip: {
        backgroundColor: "black",
        fontSize: "15px"
    }
}));
const TutorialRecordings = ()=>{
    const [purchaseModal, setPurchaseModal] = useState(false);
    const [expandedMenu, setExpandedMenu] = useState(null);

    const classes = useStyles();
    const navigation= useNavigate();

    const handleUploadTutorial=()=>{
        navigation("/upload-tutorial-recordings");
    }
    const handleEditTutorial=()=>{
        navigation("/edit-tutorial-recordings");
    }
    const handleAddTutorial=()=>{
        navigation("/add-tutorial-category");
    }
    const handleEditTutorialCategory=()=>{
        navigation("/edit-tutorial-category");
    }

    const uid = localStorage.getItem("uid");
    const adminActions = getAdminActions(uid);

    return(
        <div className="tutorial-recordings-container">
            <div className="tutorial-recordings-dashboard">
                <QuickActionsSidebar actions={adminActions} expandedMenu={expandedMenu} setExpandedMenu={setExpandedMenu} />
                <div className="tutorial-recordings-content">
                    <div className="add-btn-wrp add-btn-wrp2">
                        <div className='button-div'>
                        <button className='create-button' onClick={handleUploadTutorial} >Upload New Tutorial Recording</button>
                        <button className='create-button' onClick={handleEditTutorial}>Edit Tutorial Recordings </button>
                        <button className='create-button' onClick={handleAddTutorial}>Add Tutorial Category</button>
                        <button className='create-button' onClick={handleEditTutorialCategory}>Edit Tutorial Category</button>
                        </div>    
                    </div>
                </div>
            </div>

        </div>
    )
}
export default TutorialRecordings;